<template>
  <div class="terms bg-default">
    <div class="text-row text-container">
      <h1>{{ $t('terms-page.title-main') }}</h1>
      <div class="topic ">
        <p>{{ $t('terms-page.text-main-a') }}</p>
        <p>{{ $t('terms-page.text-main-b') }}</p>
        <p>{{ $t('terms-page.text-main-c') }}</p>
        <h5 style="margin-bottom:70px">{{ $t('terms-page.text-main-d') }}</h5>
      </div>

      <div class="topic ">
        <h4>{{ $t('terms-page.title-1') }}</h4>
        <p>{{ $t('terms-page.text-1-a') }}</p>
        <p>{{ $t('terms-page.text-1-b') }}</p>
        <p>{{ $t('terms-page.text-1-c') }}</p>
      </div>

      <div class="topic ">
        <h4>{{ $t('terms-page.title-2') }}</h4>
        <p>{{ $t('terms-page.text-2-a') }}</p>
        <p>{{ $t('terms-page.text-2-b') }}</p>
        <p>{{ $t('terms-page.text-2-c') }} <a href="https://www.seedr.cc/dynamic/dmca_policy">{{ $t('terms-page.text-2-d') }}</a></p>
        <p>{{ $t('terms-page.text-2-e') }}</p>
        <p>{{ $t('terms-page.text-2-f') }}</p>
      </div>

      <div class="topic ">
        <h4>{{ $t('terms-page.title-3') }}</h4>
        <p>{{ $t('terms-page.text-3') }}</p>
      </div>

      <div class="topic ">
        <h4>{{ $t('terms-page.title-4') }}</h4>
        <p>{{ $t('terms-page.text-4-a') }}</p>
        <p>{{ $t('terms-page.text-4-b') }}</p>
        <p>{{ $t('terms-page.text-4-c') }}</p>
      </div>

      <div class="topic ">
        <h4>{{ $t('terms-page.title-5') }}</h4>
        <p>{{ $t('terms-page.text-5-a') }}</p>
        <p>{{ $t('terms-page.text-5-b') }}</p>
      </div>

      <div class="topic ">
        <h4>{{ $t('terms-page.title-6') }}</h4>
        <p>{{ $t('terms-page.text-6-a') }}</p>
        <p>{{ $t('terms-page.text-6-b') }}</p>
      </div>

      <div class="topic ">
        <h4>{{ $t('terms-page.title-7') }}</h4>
        <p>{{ $t('terms-page.text-7') }}</p>
      </div>

      <div class="topic ">
        <h4>{{ $t('terms-page.title-8') }}</h4>
        <p>{{ $t('terms-page.text-8-a') }}</p>
        <p>{{ $t('terms-page.text-8-b') }}</p>
      </div>

      <div class="topic ">
        <h4>{{ $t('terms-page.title-9') }}</h4>
        <p>{{ $t('terms-page.text-9-a') }}</p>
        <p>{{ $t('terms-page.text-9-b') }}</p>
      </div>

      <div class="topic ">
        <h4>{{ $t('terms-page.title-10') }}</h4>
        <p>{{ $t('terms-page.text-10-a') }}</p>
        <p>{{ $t('terms-page.text-10-b') }}</p>
      </div>

      <div class="topic ">
        <h4>{{ $t('terms-page.title-11') }}</h4>
        <p>{{ $t('terms-page.text-11') }}</p>
      </div>


    </div>
  </div>
</template>

<script>

export default {
  name: 'terms-pageOfUse',
  components: {},
  props: {}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

h1 {
  margin: 5px 0 50px;
}

h4 {
  margin: 0;
}

p {
  padding: 10px 0 0;
  text-align: left;
}

</style>
